export default __webpack_public_path__ + "static/media/arrow-up-icon-white.729e2663.svg";